module.exports = __webpack_public_path__ + "static/media/car.44688f81.svg";